import { useLocation } from 'react-router-dom';
import { useUser } from 'contexts';
import Login from 'components/Login';
import Configurator from 'components/Configurator/Configurator/Configurator';
import { readQuery } from 'utils/helpers';

const Home = () => {
  const [user] = useUser();
  const location = useLocation();

  const queryParams = location ? readQuery(location) : null;

  return user || queryParams?.product ? <Configurator queryParams={queryParams} /> : <Login />;
};

export default Home;
